module.exports = __webpack_public_path__ + "static/media/door_left_rear.bd1f0902.jpg";